import React, { useState, useEffect } from 'react'
import {
  Panel,
  Table,
  Icon,
  Row,
  Col,
  Form,
  SelectPicker,
  ControlLabel,
  DatePicker,
  Uploader,
  ButtonGroup,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import TooltipButton from '../../components/buttons/TooltipButton'
import { cloneDeep, isEmpty } from 'lodash-es'
import { doneLoading, startLoading } from '../../utils/loading'
import { getLawStatus, getLawSubStatus } from '../../redux/actions/legal'
import InputNumberForm from '../../components/forms/input/InputNumberForm'
import InputForm from '../../components/forms/input/InputForm'
import ReactQuillFrom from '../../components/forms/input/ReactQuill/ReactQuillFrom'

export default function SaveLawListForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  handelPreview,
  clearValue,
  onPreview = () => {},
  onDownload = () => {},
  ...props
}) {
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [referDateDocument, setReferDateDocument] = useState(null)
  const [limitation, setLimitation] = useState(null)
  const [lawTypeValue, setLawTypeValue] = useState()
  const [lawStatusValue, setLawStatusValue] = useState()
  const [isLoading, setIsLoading] = useState()
  const [attachFiles, setAttachFiles] = useState([])
  const [deleteFileIds, setDeleteFileIds] = useState([])

  useEffect(() => {
    if (!clearValue) {
      setReferDateDocument(null)
      setLimitation(null)
    }
  }, [clearValue])

  useEffect(() => {
    if (_schema?.referDateDocument) {
      let referDate = _schema.referDateDocument.value
        ? moment(_schema?.referDateDocument?.value, DATE_PICKER_FORMAT).toDate()
        : null

      setValue(_schema?.referDateDocument?.name, referDate)
      setReferDateDocument(referDate)
    }

    if (_schema?.limitation) {
      let limitationDate = _schema?.limitation?.value
        ? moment(_schema?.limitation?.value, DATE_PICKER_FORMAT).toDate()
        : null
      setValue(_schema?.limitation?.name, limitationDate)
      setLimitation(limitationDate)
    }

    setFormSchema(_schema)
    setAttachFiles(_schema?.attachFiles?.values || [])
  }, [_schema])

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
  }

  const getLawStatusOptions = async (lawtype) => {
    startLoading()
    try {
      const response = await getLawStatus(lawtype)
      var sh = cloneDeep(formSchema)
      sh.lawStatus.value = ''
      sh.lawStatus.options = response?.results || []
      setFormSchema(sh)
    } catch (e) {}
    doneLoading()
  }

  const getLawSubStatusOptions = async (lawtype, lawStatus) => {
    startLoading()
    try {
      const response = await getLawSubStatus(lawtype, lawStatus)
      var sh = cloneDeep(formSchema)
      sh.lawSubStatus.value = ''
      sh.lawSubStatus.options = response?.results || []
      setFormSchema(sh)
    } catch (e) {}
    doneLoading()
  }

  const onDelete = (fileObj, index) => {
    var fileIds = [...deleteFileIds]
    fileIds.push(fileObj.id)

    attachFiles.splice(index, 1)

    setAttachFiles(attachFiles)
    setDeleteFileIds(fileIds)

    setValue('deleteFileIds', fileIds)
  }

  return (
    <>
      <Panel
        collapsible
        defaultExpanded
        bordered
        // style={{
        //   border: '2px solid #4e4b488c',
        // }}
      >
        <Controller
          key={'deleteFileIds'}
          name={'deleteFileIds'}
          control={control}
          defaultValue={deleteFileIds}
        />

        <Form>
          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage error={errors[formSchema.lawType.name]} style={{ marginBottom: 10 }} />
              <ControlLabel style={{ marginTop: 10 }}>
                {requiredFiled(formSchema.lawType.validators, formSchema.lawType.label)}
              </ControlLabel>
              <Controller
                name={formSchema.lawType.name}
                control={control}
                defaultValue={formSchema.lawType.value}
                rules={isValidators(formSchema.lawType.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.lawType.options}
                      searchable={false}
                      disabled={formSchema.lawType.disabled}
                      value={props.value}
                      block
                      placeholder={formSchema.lawType.hint || `เลือก${formSchema.lawType.label}`}
                      onChange={(value) => {
                        props.onChange(value)
                        setLawTypeValue(value)
                        getLawStatusOptions(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <div style={{ marginTop: -16 }}>
                <InputForm
                  schema={formSchema.litigationName}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <InputForm
                schema={formSchema.projectCode}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <InputForm
                schema={formSchema.docNumberOfPurchase}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <div style={{ marginTop: -15 }}>
                <InputForm
                  schema={formSchema.referCodeDocument}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  onChange={(value) => {
                    // setTargetUnit(value)
                  }}
                />
              </div>
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.referDateDocument.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {requiredFiled(
                  formSchema.referDateDocument.validators,
                  formSchema.referDateDocument.label
                )}
              </ControlLabel>
              <Controller
                key={formSchema.referDateDocument.name}
                name={formSchema.referDateDocument.name}
                control={control}
                defaultValue={
                  referDateDocument
                  // formSchema.referDateDocument.value
                  //   ? moment(formSchema.referDateDocument.value, DATE_PICKER_FORMAT).toDate()
                  //   : null
                }
                rules={isValidators(formSchema.referDateDocument.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      value={referDateDocument}
                      disabled={formSchema.referDateDocument.disabled}
                      onChange={(value) => {
                        // const date = moment(value).format(DATE_PICKER_FORMAT)
                        props.onChange(value)
                        setReferDateDocument(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{
                padding: '8px',
              }}
            >
              <ReactQuillFrom
                schema={formSchema.causeOfWrongdoing}
                toolbar={[]}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                toolbars={[['bold', 'italic', 'underline']]}
              />
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ padding: '8px' }}>
              <ReactQuillFrom
                schema={formSchema.note}
                toolbar={[]}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                toolbars={[['bold', 'italic', 'underline']]}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                padding: '8px',
              }}
            >
              <InputForm
                schema={formSchema.offender}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                padding: '8px',
              }}
            >
              <InputNumberForm
                schema={formSchema.damages}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                decimalScale={2}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <div style={{ marginTop: -15 }}>
                <InputNumberForm
                  schema={formSchema.capital}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  decimalScale={2}
                />
              </div>
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.limitation.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {requiredFiled(formSchema.limitation.validators, formSchema.limitation.label)}
              </ControlLabel>
              <Controller
                key={formSchema.limitation.name}
                name={formSchema.limitation.name}
                control={control}
                defaultValue={
                  limitation
                  // formSchema.limitation.value
                  //   ? moment(formSchema.limitation.value, DATE_PICKER_FORMAT).toDate()
                  //   : null
                }
                rules={isValidators(formSchema.limitation.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      value={limitation}
                      disabled={formSchema.limitation.disabled}
                      onChange={(value) => {
                        // const date = moment(value).format(DATE_PICKER_FORMAT)
                        props.onChange(value)
                        setLimitation(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.lawStatus.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {formSchema.lawStatus.options.length > 0 && !formSchema.lawStatus.disabled
                  ? requiredFiled(formSchema.lawStatus.validators, formSchema.lawStatus.label)
                  : formSchema.lawStatus.label}
              </ControlLabel>
              <Controller
                name={formSchema.lawStatus.name}
                control={control}
                defaultValue={formSchema.lawStatus.value}
                rules={
                  formSchema.lawStatus.options.length > 0 && !formSchema.lawStatus.disabled
                    ? isValidators(formSchema.lawStatus.validators)
                    : {}
                }
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.lawStatus.options}
                      searchable={false}
                      value={props.value}
                      block
                      placeholder={
                        formSchema.lawStatus.hint || `เลือก${formSchema.lawStatus.label}`
                      }
                      disabled={
                        formSchema.lawStatus.options.length < 1 || formSchema.lawStatus.disabled
                      }
                      onChange={(value) => {
                        props.onChange(value)
                        setLawStatusValue(value)
                        getLawSubStatusOptions(lawTypeValue, value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.lawSubStatus.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {formSchema.lawSubStatus.options.length > 0
                  ? requiredFiled(formSchema.lawSubStatus.validators, formSchema.lawSubStatus.label)
                  : formSchema.lawSubStatus.label}
              </ControlLabel>
              <Controller
                name={formSchema.lawSubStatus.name}
                control={control}
                defaultValue={formSchema.lawSubStatus.value}
                rules={
                  formSchema.lawSubStatus.options.length > 0
                    ? isValidators(formSchema.lawSubStatus.validators)
                    : {}
                }
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.lawSubStatus.options}
                      searchable={false}
                      value={props.value}
                      block
                      placeholder={
                        formSchema.lawSubStatus.hint || `เลือก${formSchema.lawSubStatus.label}`
                      }
                      disabled={
                        formSchema.lawSubStatus.options.length < 1 || formSchema.lawStatus.disabled
                      }
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
          {!formSchema?.disabled && (
            <Row>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <Controller
                  name={'file'}
                  control={control}
                  defaultValue={undefined}
                  render={(props) => {
                    return (
                      <Uploader
                        draggable
                        autoUpload={false}
                        multiple={true}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            // let files = []

                            // console.log('file ', fileList)

                            // files.push(fileList[fileList.length - 1])

                            props.onChange(fileList)
                          }
                        }}
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
            </Row>
          )}

          {attachFiles && (
            <Row>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <Table height={300} wordWrap bordered data={attachFiles}>
                  <Column width={90} align="center">
                    <HeaderCell>ไฟล์ที่</HeaderCell>
                    <Cell>
                      {(_, index) => {
                        return index + 1
                      }}
                    </Cell>
                  </Column>
                  <Column minWidth={300} flexGrow={1}>
                    <HeaderCell>ชื่อไฟล์</HeaderCell>
                    <Cell>
                      {(rowData) => {
                        return rowData.label
                      }}
                    </Cell>
                  </Column>

                  <Column width={200} align="center">
                    <HeaderCell></HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return (
                          <ButtonGroup>
                            <TooltipButton
                              isStart={true}
                              icon="eye"
                              tooltip={`แสดง`}
                              disabled={isLoading}
                              onClick={(e) => onPreview(rowData)}
                            ></TooltipButton>
                            <TooltipButton
                              isStart={false}
                              icon="download"
                              tooltip={`ดาวน์โหลด`}
                              disabled={isLoading}
                              onClick={(e) => onDownload(rowData)}
                            ></TooltipButton>
                            {!formSchema?.disabled && (
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                disabled={isLoading}
                                onClick={(e) => onDelete(rowData, index)}
                              ></TooltipButton>
                            )}
                          </ButtonGroup>
                        )
                      }}
                    </Cell>
                  </Column>
                </Table>
              </Col>
            </Row>
          )}
        </Form>
      </Panel>
    </>
  )
}
